import { AuditableEntity } from "./audible-entity.model";

export class GasTwo extends AuditableEntity {
    constructor(_Id?: number, _Date?: Date, _MarketID?: string, _ProductName?: string, _SettlementPrice?: number, _StripName?: string,
        _CreatedBy?: string, _CreatedDate?: Date, _UpdatedBy?: string, _UpdatedDate?: Date, _DeletedBy?: string, _DeletedDate?: Date) {

        super(_CreatedBy, _CreatedDate, _UpdatedBy, _UpdatedDate, _DeletedBy, _DeletedDate);

        this.Id = _Id;
        this.Date = _Date;
        this.MarketID = _MarketID;
        this.ProductName = _ProductName;
        this.SettlementPrice = _SettlementPrice;
        this.StripName = _StripName;
    }

    public Id: number;
    public Date: Date;
    public MarketID: string;
    public ProductName: string;
    public SettlementPrice: number;
    public StripName: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/gastwo.model.ts